import React from 'react';
import { useTranslation } from 'react-i18next';

import MyButton from '../button/Button';
import './disable-warning.scss';

interface DisableSwitchWarningProperties {
  selectedId?: string | null;
  onCancel: () => void;
  message: JSX.Element | string;
  onConfirm: (selectId?: string | null) => void;
  cancelLabel?: string;
  confirmLabel?: string;
}
/**
 * A warning modal that prompts the user before disabling.
 * @param {DisableSwitchWarningProperties} props - The properties for the DisableSwitchWarning component.
 * @param {string | null} [props.selectedId] - The ID to disable.
 * @param {Function} props.onCancel - Callback function when the user cancels.
 * @param {Function} props.onConfirm - Callback function when the user confirms the action.
 * @returns {JSX.Element} The rendered component.
 */
function DisableSwitchWarning({
  selectedId,
  message,
  onCancel,
  cancelLabel,
  confirmLabel,
  onConfirm,
}: DisableSwitchWarningProperties) {
  const { t } = useTranslation('sharedComp');
  return (
    <div className="disable-warning-wrap">
      <div className="disable-waring-content">
        <h1>{t('warning')} ⚠️</h1>
        <p>
          <span>{message}</span>
        </p>
      </div>
      <div className="disable-button">
        <MyButton
          label={cancelLabel || t('cancel')}
          buttonType="back"
          onClickFunc={onCancel}
          disableHoverEffect
        />
        <MyButton
          label={confirmLabel || t('ok')}
          buttonType="warning"
          onClickFunc={() => onConfirm(selectedId)}
        />
      </div>
    </div>
  );
}

DisableSwitchWarning.defaultProps = {
  selectedId: null,
  confirmLabel: '',
  cancelLabel: '',
};

export default DisableSwitchWarning;
